

import { useParams } from "react-router-dom"

import { LogsStream } from "../../../Plans/Templates/LogsStream";

export function Logs({ kernel }) {
    const { id } = useParams()
    return (<LogsStream kernel={kernel} profileId={id} logType='profile' url={`/dohzel/profile/${id}/logs`} endpoint={`/dohzel/logs/dump?profileId=${id}`} />)
}